export const VERSION = '0.80.0'; // x-release-please-version
//# sourceMappingURL=version.mjs.map